


















import { Component, Vue, Prop } from 'vue-property-decorator';
import isMobile from '@/utils/isMobile';

@Component
export default class Logo extends Vue {
  @Prop({ type: String, required: true }) src!: string;
  private isMobile!: boolean;

  created() {
    this.isMobile = isMobile();
  }
}
